import React from "react";

import { Link } from "react-router-dom";

import { toPersianNum } from "../../assets/utils";

import PaginationItemBtn from "./PaginationItem.styles";

const PaginationItem = ({
  number,
  current,
  onClick,
  content = " ",
  border,
}) => {
  return (
    <div>
      <Link to={`../page/${number}`}>
        {/* {console.log(number)} */}
        <PaginationItemBtn
          className={current}
          current={current}
          border={border}
          onClick={onClick}
        >
          {content ? toPersianNum(content) : null}
        </PaginationItemBtn>
      </Link>
    </div>
  );
};

export default PaginationItem;
